import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountClient, AccountDto } from '../../api-connector/sso-connector';
import { AuthService } from '../../services/auth.service';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-account-search-control',
  templateUrl: './account-search-control.component.html',
  styleUrls: ['./account-search-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccountSearchControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AccountSearchControlComponent),
      multi: true,
    }
  ]
})
export class AccountSearchControlComponent extends BaseAutocompleteControl<AccountDto> implements OnInit {

  constructor(
    private accountClient: AccountClient,
    private auth: AuthService,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Custom fetch: Admins can search all, users see only themselves
   */
  protected fetchItems(searchValue: string): Observable<AccountDto[]> {
    if (this.auth.laQuanTriVien()) {
      // Admin: search by keyword
      const cacheKey = `accounts_search_${searchValue}`;
      return this.cache.wrap(cacheKey, this.accountClient.getAccountByKeySearch(searchValue).pipe(
        map(items => items || [])
      ));
    } else {
      // Regular user: show only current account if it matches
      const currentUser = this.auth.getAccount();
      const matches = currentUser && currentUser.fullName?.toLowerCase().includes(searchValue.toLowerCase())
        ? [currentUser]
        : [];
      return of(matches);
    }
  }

  getDisplayValue(item: AccountDto | null): string {
    return item?.fullName || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof AccountDto;
  }
}
